import {
  PrimitiveClasses_getInstance28ukyr6i8fs0q as PrimitiveClasses_getInstance,
  arrayOf1akklvh2at202 as arrayOf,
  createKType1lgox3mzhchp5 as createKType,
  Unit_instance104q5opgivhr8 as Unit_instance,
  VOID7hggqo3abtya as VOID,
  isBlank1dvkhjjvox3p0 as isBlank,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$310sysrobvll9 as IllegalArgumentException_init_$Create$,
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  IllegalStateException_init_$Create$3ib9qa3pip8n4 as IllegalStateException_init_$Create$,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  charArray2ujmm1qusno00 as charArray,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  concatToString3cxf0c1gqonpo as concatToString,
  _Char___init__impl__6a9atx281r2pd9o601g as _Char___init__impl__6a9atx,
  numberToChar93r9buh19yek as numberToChar,
  indexOf1xbs558u7wr52 as indexOf,
  Char__toInt_impl_vasixd2xlaiz5u3itpv as Char__toInt_impl_vasixd,
  LinkedHashMap_init_$Create$1p3p95clvi93w as LinkedHashMap_init_$Create$,
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  Entry2xmjmyutzoq3p as Entry,
  isInterface3d6p8outrmvmk as isInterface,
  toString30pk9tzaqopn as toString_0,
  toString35i91qxh73cps as toString_1,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Element2gr7ezmxqaln7 as Element,
  concatToString2syawgu50khxi as concatToString_0,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  ArrayList_init_$Create$1s1wkrw82c0iw as ArrayList_init_$Create$,
  KtSetjrjc7fhfd6b9 as KtSet,
  KtMutableSetwuwn7k5m570a as KtMutableSet,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  Enum3alwj03lh1n41 as Enum,
  firstOrNull1982767dljvdy as firstOrNull,
  ArrayList_init_$Create$2qnngtk1et9r9 as ArrayList_init_$Create$_0,
  LinkedHashMap_init_$Create$7ps311k1ff73 as LinkedHashMap_init_$Create$_0,
  KtMap140uvy3s5zad8 as KtMap,
  addAll1k27qatfgp3k5 as addAll,
  toSet2orjxp16sotqu as toSet,
  emptySetcxexqki71qfa as emptySet,
  emptyMapr06gerzljqtm as emptyMap,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2v6cggk171b6e as equals_0,
  setOf1u3mizs95ngxo as setOf,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  StringBuilder_init_$Create$23o1ixl6cos5l as StringBuilder_init_$Create$,
  get_lastIndexld83bqhfgcdd as get_lastIndex,
  Char__plus_impl_qi7pgj1zq2c0uiotg93 as Char__plus_impl_qi7pgj,
  LazyThreadSafetyMode_PUBLICATION_getInstance2x9bac6dffafm as LazyThreadSafetyMode_PUBLICATION_getInstance,
  lazy1261dae0bgscp as lazy,
  Long2qws0ah9gnpki as Long,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  objectCreate1ve4bgxiu4x98 as objectCreate,
  Comparable198qfk8pnblz0 as Comparable,
  enumEntries20mr21zbe3az4 as enumEntries,
  CoroutineImpl2sn3kjnwmfr10 as CoroutineImpl,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  initMetadataForCoroutine1i7lbatuf5bnt as initMetadataForCoroutine,
  KtMutableList1beimitadwkna as KtMutableList,
  toMutableList20rdgwi7d3cwi as toMutableList,
  ArrayList3it5z8td81qkl as ArrayList,
  emptyList1g2z5xcrvp2zy as emptyList,
  get_lastIndex1yw0x4k50k51w as get_lastIndex_0,
  last1vo29oleiqj36 as last,
  mutableListOf6oorvk2mtdmp as mutableListOf,
  anyToString3ho3k49fc56mj as anyToString,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  extendThrowable112s72v177bbq as extendThrowable,
  captureStack1fzi4aczwc4hg as captureStack,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz81wclroc5pw7j2 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  Result__exceptionOrNull_impl_p6xea9boty10p2dkn4 as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_isFailure__impl__jpirivzehaw445b0cy as _Result___get_isFailure__impl__jpiriv,
  Continuation1aa2oekvx7jm7 as Continuation,
  intercepted2ogpsikxxj4u0 as intercepted,
  KProperty1ca4yb4wlo496 as KProperty1,
  lazy2hsh8ze7j6ikd as lazy_0,
  isNaNymqb93xtq8w8 as isNaN_0,
  numberToLong1a4cndvg6c52s as numberToLong,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalStateException_init_$Init$13tvpwythio9e as IllegalStateException_init_$Init$,
  toList3jhuyej2anx2q as toList,
  _Result___get_value__impl__bjfvqgo6z1uu11rodr as _Result___get_value__impl__bjfvqg,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
} from './kotlin-kotlin-stdlib.mjs';
import {
  SupervisorJobythnfxkr3jxc as SupervisorJob,
  Key_instancexdagtxajq561 as Key_instance,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
  recoverStackTrace2i3si2i8nvw1k as recoverStackTrace,
} from './kotlinx-coroutines-core.mjs';
import {
  Buffergs925ekssbch as Buffer,
  readByteArray1fhzfwi2j014k as readByteArray,
  IOException1wyutdmfe71nu as IOException,
} from './kotlinx-io-kotlinx-io-core.mjs';
import {
  get_size2imoy2jq11jxl as get_size,
  writeText19qfzm98fbm4l as writeText,
} from './ktor-ktor-io.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer,
  PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor,
  UnknownFieldException_init_$Create$1mnsp66c6fnup as UnknownFieldException_init_$Create$,
  IntSerializer_getInstance9scrtcljaiv6 as IntSerializer_getInstance,
  LongSerializer_getInstance3iic24guzegu7 as LongSerializer_getInstance,
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException,
} from './kotlinx-serialization-kotlinx-serialization-core.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForClass(AttributeKey, 'AttributeKey');
function get(key) {
  var tmp0_elvis_lhs = this.t3o(key);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalStateException_init_$Create$('No instance for key ' + key.toString());
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
initMetadataForInterface(Attributes, 'Attributes');
initMetadataForClass(CaseInsensitiveMap, 'CaseInsensitiveMap', CaseInsensitiveMap, VOID, [KtMutableMap]);
initMetadataForClass(Entry_0, 'Entry', VOID, VOID, [Entry]);
initMetadataForClass(SilentSupervisor$$inlined$CoroutineExceptionHandler$1, VOID, VOID, AbstractCoroutineContextElement, [AbstractCoroutineContextElement, Element]);
initMetadataForClass(DelegatingMutableSet$iterator$1);
initMetadataForClass(DelegatingMutableSet, 'DelegatingMutableSet', VOID, VOID, [KtMutableSet]);
initMetadataForClass(Platform, 'Platform');
initMetadataForObject(Jvm, 'Jvm', VOID, Platform);
initMetadataForObject(Native, 'Native', VOID, Platform);
initMetadataForClass(Js, 'Js', VOID, Platform);
initMetadataForClass(WasmJs, 'WasmJs', VOID, Platform);
initMetadataForClass(JsPlatform, 'JsPlatform', VOID, Enum);
initMetadataForObject(PlatformUtils, 'PlatformUtils');
function get_0(name) {
  var tmp0_safe_receiver = this.g3q(name);
  return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
}
function forEach(body) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = this.i3q().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var k = element.s();
    // Inline function 'kotlin.collections.component2' call
    var v = element.t();
    body(k, v);
  }
  return Unit_instance;
}
initMetadataForInterface(StringValues, 'StringValues');
initMetadataForClass(StringValuesBuilderImpl, 'StringValuesBuilderImpl', StringValuesBuilderImpl);
initMetadataForClass(StringValuesImpl, 'StringValuesImpl', StringValuesImpl, VOID, [StringValues]);
initMetadataForClass(StringValuesSingleImpl$entries$1, VOID, VOID, VOID, [Entry]);
initMetadataForClass(StringValuesSingleImpl, 'StringValuesSingleImpl', VOID, VOID, [StringValues]);
initMetadataForClass(CaseInsensitiveString, 'CaseInsensitiveString');
initMetadataForClass(ChannelIOException, 'ChannelIOException', VOID, IOException);
initMetadataForClass(CopyOnWriteHashMap, 'CopyOnWriteHashMap', CopyOnWriteHashMap);
initMetadataForCompanion(Companion);
initMetadataForObject($serializer, '$serializer', VOID, VOID, [GeneratedSerializer]);
initMetadataForClass(GMTDate, 'GMTDate', VOID, VOID, [Comparable], VOID, VOID, {0: $serializer_getInstance});
initMetadataForCompanion(Companion_0);
initMetadataForClass(WeekDay, 'WeekDay', VOID, Enum);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Month, 'Month', VOID, Enum);
initMetadataForClass(Symbol, 'Symbol');
initMetadataForClass(LockFreeLinkedListNode, 'LockFreeLinkedListNode');
initMetadataForClass(Removed, 'Removed');
initMetadataForClass(OpDescriptor, 'OpDescriptor');
initMetadataForCoroutine($proceedLoopCOROUTINE$0, CoroutineImpl);
initMetadataForClass(PipelineContext, 'PipelineContext', VOID, VOID, [CoroutineScope], [1, 0]);
initMetadataForClass(DebugPipelineContext, 'DebugPipelineContext', VOID, PipelineContext, VOID, [1, 0]);
initMetadataForCompanion(Companion_2);
initMetadataForClass(PhaseContent, 'PhaseContent');
initMetadataForClass(Pipeline, 'Pipeline', VOID, VOID, VOID, [2]);
initMetadataForClass(PipelinePhase, 'PipelinePhase');
initMetadataForClass(InvalidPhaseException, 'InvalidPhaseException', VOID, Error);
initMetadataForClass(PipelinePhaseRelation, 'PipelinePhaseRelation');
initMetadataForClass(After, 'After', VOID, PipelinePhaseRelation);
initMetadataForClass(Before, 'Before', VOID, PipelinePhaseRelation);
initMetadataForObject(Last, 'Last', VOID, PipelinePhaseRelation);
initMetadataForClass(SuspendFunctionGun$continuation$1, VOID, VOID, VOID, [Continuation]);
initMetadataForClass(SuspendFunctionGun, 'SuspendFunctionGun', VOID, PipelineContext, VOID, [0, 1]);
initMetadataForClass(TypeInfo, 'TypeInfo');
initMetadataForClass(InvalidTimestampException, 'InvalidTimestampException', VOID, IllegalStateException);
initMetadataForClass(AttributesJs, 'AttributesJs', AttributesJs, VOID, [Attributes]);
initMetadataForClass(KtorSimpleLogger$1);
initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
//endregion
function AttributeKey(name, type) {
  var tmp;
  if (type === VOID) {
    // Inline function 'io.ktor.util.reflect.typeInfo' call
    var tmp_0 = PrimitiveClasses_getInstance().lb();
    // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
    var tmp_1;
    try {
      tmp_1 = createKType(PrimitiveClasses_getInstance().lb(), arrayOf([]), false);
    } catch ($p) {
      var tmp_2;
      if ($p instanceof Error) {
        var _unused_var__etf5q3 = $p;
        tmp_2 = null;
      } else {
        throw $p;
      }
      tmp_1 = tmp_2;
    }
    var tmp$ret$0 = tmp_1;
    tmp = new TypeInfo(tmp_0, tmp$ret$0);
  } else {
    tmp = type;
  }
  type = tmp;
  this.q3o_1 = name;
  this.r3o_1 = type;
  // Inline function 'kotlin.text.isNotBlank' call
  var this_0 = this.q3o_1;
  // Inline function 'kotlin.require' call
  if (!!isBlank(this_0)) {
    var message = "Name can't be blank";
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(AttributeKey).toString = function () {
  return 'AttributeKey: ' + this.q3o_1;
};
protoOf(AttributeKey).hashCode = function () {
  var result = getStringHashCode(this.q3o_1);
  result = imul(result, 31) + this.r3o_1.hashCode() | 0;
  return result;
};
protoOf(AttributeKey).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AttributeKey))
    return false;
  var tmp0_other_with_cast = other instanceof AttributeKey ? other : THROW_CCE();
  if (!(this.q3o_1 === tmp0_other_with_cast.q3o_1))
    return false;
  if (!this.r3o_1.equals(tmp0_other_with_cast.r3o_1))
    return false;
  return true;
};
function Attributes() {
}
function putAll(_this__u8e3s4, other) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = other.y3o().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    _this__u8e3s4.v3o(element instanceof AttributeKey ? element : THROW_CCE(), other.s3o(element));
  }
}
var BASE64_INVERSE_ALPHABET;
function encodeBase64(_this__u8e3s4) {
  _init_properties_Base64_kt__ymmsz3();
  var array = _this__u8e3s4;
  var position = 0;
  var writeOffset = 0;
  var charArray_0 = charArray((imul(_this__u8e3s4.length, 8) / 6 | 0) + 3 | 0);
  while ((position + 3 | 0) <= array.length) {
    var first = array[position];
    var second = array[position + 1 | 0];
    var third = array[position + 2 | 0];
    position = position + 3 | 0;
    var chunk = (first & 255) << 16 | (second & 255) << 8 | third & 255;
    var inductionVariable = 3;
    if (0 <= inductionVariable)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        var char = chunk >> imul(6, index) & 63;
        var _unary__edvuaz = writeOffset;
        writeOffset = _unary__edvuaz + 1 | 0;
        // Inline function 'io.ktor.util.toBase64' call
        charArray_0[_unary__edvuaz] = charSequenceGet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', char);
      }
       while (0 <= inductionVariable);
  }
  var remaining = array.length - position | 0;
  if (remaining === 0)
    return concatToString(charArray_0, 0, writeOffset);
  var tmp;
  if (remaining === 1) {
    tmp = (array[position] & 255) << 16 | 0 | 0;
  } else {
    tmp = (array[position] & 255) << 16 | (array[position + 1 | 0] & 255) << 8 | 0;
  }
  var chunk_0 = tmp;
  var padSize = imul(3 - remaining | 0, 8) / 6 | 0;
  var inductionVariable_0 = 3;
  if (padSize <= inductionVariable_0)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + -1 | 0;
      var char_0 = chunk_0 >> imul(6, index_0) & 63;
      var _unary__edvuaz_0 = writeOffset;
      writeOffset = _unary__edvuaz_0 + 1 | 0;
      // Inline function 'io.ktor.util.toBase64' call
      charArray_0[_unary__edvuaz_0] = charSequenceGet('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', char_0);
    }
     while (!(index_0 === padSize));
  // Inline function 'kotlin.repeat' call
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < padSize)
    do {
      var index_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var _unary__edvuaz_1 = writeOffset;
      writeOffset = _unary__edvuaz_1 + 1 | 0;
      charArray_0[_unary__edvuaz_1] = _Char___init__impl__6a9atx(61);
    }
     while (inductionVariable_1 < padSize);
  return concatToString(charArray_0, 0, writeOffset);
}
var properties_initialized_Base64_kt_5g824v;
function _init_properties_Base64_kt__ymmsz3() {
  if (!properties_initialized_Base64_kt_5g824v) {
    properties_initialized_Base64_kt_5g824v = true;
    var tmp = 0;
    var tmp_0 = new Int32Array(256);
    while (tmp < 256) {
      var tmp_1 = tmp;
      tmp_0[tmp_1] = indexOf('ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/', numberToChar(tmp_1));
      tmp = tmp + 1 | 0;
    }
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(45);
    var tmp_2 = Char__toInt_impl_vasixd(this_0);
    // Inline function 'kotlin.code' call
    var this_1 = _Char___init__impl__6a9atx(43);
    tmp_0[tmp_2] = tmp_0[Char__toInt_impl_vasixd(this_1)];
    // Inline function 'kotlin.code' call
    var this_2 = _Char___init__impl__6a9atx(95);
    var tmp_3 = Char__toInt_impl_vasixd(this_2);
    // Inline function 'kotlin.code' call
    var this_3 = _Char___init__impl__6a9atx(47);
    tmp_0[tmp_3] = tmp_0[Char__toInt_impl_vasixd(this_3)];
    BASE64_INVERSE_ALPHABET = tmp_0;
  }
}
function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj($this$DelegatingMutableSet) {
  return $this$DelegatingMutableSet.z3o_1;
}
function CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0($this$DelegatingMutableSet) {
  return caseInsensitive($this$DelegatingMutableSet);
}
function CaseInsensitiveMap$_get_entries_$lambda_r32w19($this$DelegatingMutableSet) {
  return new Entry_0($this$DelegatingMutableSet.s().z3o_1, $this$DelegatingMutableSet.t());
}
function CaseInsensitiveMap$_get_entries_$lambda_r32w19_0($this$DelegatingMutableSet) {
  return new Entry_0(caseInsensitive($this$DelegatingMutableSet.s()), $this$DelegatingMutableSet.t());
}
function CaseInsensitiveMap() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.b3p_1 = LinkedHashMap_init_$Create$();
}
protoOf(CaseInsensitiveMap).m = function () {
  return this.b3p_1.m();
};
protoOf(CaseInsensitiveMap).c3p = function (key) {
  return this.b3p_1.y1(new CaseInsensitiveString(key));
};
protoOf(CaseInsensitiveMap).y1 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return false;
  return this.c3p((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(CaseInsensitiveMap).h2a = function (key) {
  return this.b3p_1.a2(caseInsensitive(key));
};
protoOf(CaseInsensitiveMap).a2 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return null;
  return this.h2a((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(CaseInsensitiveMap).p = function () {
  return this.b3p_1.p();
};
protoOf(CaseInsensitiveMap).d2 = function () {
  this.b3p_1.d2();
};
protoOf(CaseInsensitiveMap).d3p = function (key, value) {
  return this.b3p_1.h2(caseInsensitive(key), value);
};
protoOf(CaseInsensitiveMap).h2 = function (key, value) {
  var tmp = (!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE();
  return this.d3p(tmp, !(value == null) ? value : THROW_CCE());
};
protoOf(CaseInsensitiveMap).e3p = function (from) {
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = from.r().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = element.s();
    // Inline function 'kotlin.collections.component2' call
    var value = element.t();
    this.d3p(key, value);
  }
};
protoOf(CaseInsensitiveMap).j2 = function (from) {
  return this.e3p(from);
};
protoOf(CaseInsensitiveMap).f3p = function (key) {
  return this.b3p_1.i2(caseInsensitive(key));
};
protoOf(CaseInsensitiveMap).i2 = function (key) {
  if (!(!(key == null) ? typeof key === 'string' : false))
    return null;
  return this.f3p((!(key == null) ? typeof key === 'string' : false) ? key : THROW_CCE());
};
protoOf(CaseInsensitiveMap).b2 = function () {
  var tmp = this.b3p_1.b2();
  var tmp_0 = CaseInsensitiveMap$_get_keys_$lambda_ptzlqj;
  return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_keys_$lambda_ptzlqj_0);
};
protoOf(CaseInsensitiveMap).r = function () {
  var tmp = this.b3p_1.r();
  var tmp_0 = CaseInsensitiveMap$_get_entries_$lambda_r32w19;
  return new DelegatingMutableSet(tmp, tmp_0, CaseInsensitiveMap$_get_entries_$lambda_r32w19_0);
};
protoOf(CaseInsensitiveMap).c2 = function () {
  return this.b3p_1.c2();
};
protoOf(CaseInsensitiveMap).equals = function (other) {
  var tmp;
  if (other == null) {
    tmp = true;
  } else {
    tmp = !(other instanceof CaseInsensitiveMap);
  }
  if (tmp)
    return false;
  return equals(other.b3p_1, this.b3p_1);
};
protoOf(CaseInsensitiveMap).hashCode = function () {
  return hashCode(this.b3p_1);
};
function Entry_0(key, value) {
  this.g3p_1 = key;
  this.h3p_1 = value;
}
protoOf(Entry_0).s = function () {
  return this.g3p_1;
};
protoOf(Entry_0).t = function () {
  return this.h3p_1;
};
protoOf(Entry_0).hashCode = function () {
  return (527 + hashCode(ensureNotNull(this.g3p_1)) | 0) + hashCode(ensureNotNull(this.h3p_1)) | 0;
};
protoOf(Entry_0).equals = function (other) {
  var tmp;
  if (other == null) {
    tmp = true;
  } else {
    tmp = !(!(other == null) ? isInterface(other, Entry) : false);
  }
  if (tmp)
    return false;
  return equals(other.s(), this.g3p_1) && equals(other.t(), this.h3p_1);
};
protoOf(Entry_0).toString = function () {
  return toString_0(this.g3p_1) + '=' + toString_0(this.h3p_1);
};
function toCharArray(_this__u8e3s4) {
  var tmp = 0;
  var tmp_0 = _this__u8e3s4.length;
  var tmp_1 = charArray(tmp_0);
  while (tmp < tmp_0) {
    var tmp_2 = tmp;
    tmp_1[tmp_2] = charSequenceGet(_this__u8e3s4, tmp_2);
    tmp = tmp + 1 | 0;
  }
  return tmp_1;
}
function isLowerCase(_this__u8e3s4) {
  // Inline function 'kotlin.text.lowercaseChar' call
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.js.unsafeCast' call
  var tmp$ret$2 = toString_1(_this__u8e3s4).toLowerCase();
  return charSequenceGet(tmp$ret$2, 0) === _this__u8e3s4;
}
function caseInsensitiveMap() {
  return new CaseInsensitiveMap();
}
function SilentSupervisor(parent) {
  parent = parent === VOID ? null : parent;
  var tmp = SupervisorJob(parent);
  // Inline function 'kotlinx.coroutines.CoroutineExceptionHandler' call
  var tmp$ret$0 = new SilentSupervisor$$inlined$CoroutineExceptionHandler$1();
  return tmp.jg(tmp$ret$0);
}
function SilentSupervisor$$inlined$CoroutineExceptionHandler$1() {
  AbstractCoroutineContextElement.call(this, Key_instance);
}
protoOf(SilentSupervisor$$inlined$CoroutineExceptionHandler$1).k1l = function (context, exception) {
  return Unit_instance;
};
function get_digits() {
  _init_properties_Crypto_kt__txayzl();
  return digits;
}
var digits;
function generateNonce(size) {
  _init_properties_Crypto_kt__txayzl();
  // Inline function 'io.ktor.utils.io.core.buildPacket' call
  var builder = new Buffer();
  while (get_size(builder) < size) {
    writeText(builder, generateNonce_0());
  }
  return readByteArray(builder, size);
}
function hex(bytes) {
  _init_properties_Crypto_kt__txayzl();
  var result = charArray(imul(bytes.length, 2));
  var resultIndex = 0;
  var digits = get_digits();
  var inductionVariable = 0;
  var last = bytes.length;
  while (inductionVariable < last) {
    var element = bytes[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var b = element & 255;
    var _unary__edvuaz = resultIndex;
    resultIndex = _unary__edvuaz + 1 | 0;
    result[_unary__edvuaz] = digits[b >> 4];
    var _unary__edvuaz_0 = resultIndex;
    resultIndex = _unary__edvuaz_0 + 1 | 0;
    result[_unary__edvuaz_0] = digits[b & 15];
  }
  return concatToString_0(result);
}
var properties_initialized_Crypto_kt_8g5vqb;
function _init_properties_Crypto_kt__txayzl() {
  if (!properties_initialized_Crypto_kt_8g5vqb) {
    properties_initialized_Crypto_kt_8g5vqb = true;
    digits = toCharArray('0123456789abcdef');
  }
}
function DelegatingMutableSet$iterator$1(this$0) {
  this.k3p_1 = this$0;
  this.j3p_1 = this$0.l3p_1.j();
}
protoOf(DelegatingMutableSet$iterator$1).k = function () {
  return this.j3p_1.k();
};
protoOf(DelegatingMutableSet$iterator$1).l = function () {
  return this.k3p_1.m3p_1(this.j3p_1.l());
};
protoOf(DelegatingMutableSet$iterator$1).c4 = function () {
  return this.j3p_1.c4();
};
function DelegatingMutableSet(delegate, convertTo, convert) {
  this.l3p_1 = delegate;
  this.m3p_1 = convertTo;
  this.n3p_1 = convert;
  this.o3p_1 = this.l3p_1.m();
}
protoOf(DelegatingMutableSet).p3p = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = this.n3p_1(item);
    destination.e(tmp$ret$0);
  }
  return destination;
};
protoOf(DelegatingMutableSet).q3p = function (_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$0 = this.m3p_1(item);
    destination.e(tmp$ret$0);
  }
  return destination;
};
protoOf(DelegatingMutableSet).m = function () {
  return this.o3p_1;
};
protoOf(DelegatingMutableSet).r3p = function (element) {
  return this.l3p_1.e(this.n3p_1(element));
};
protoOf(DelegatingMutableSet).e = function (element) {
  return this.r3p((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(DelegatingMutableSet).s3p = function (elements) {
  return this.l3p_1.n(this.p3p(elements));
};
protoOf(DelegatingMutableSet).n = function (elements) {
  return this.s3p(elements);
};
protoOf(DelegatingMutableSet).d2 = function () {
  this.l3p_1.d2();
};
protoOf(DelegatingMutableSet).t3p = function (element) {
  return this.l3p_1.u1(this.n3p_1(element));
};
protoOf(DelegatingMutableSet).u1 = function (element) {
  if (!(element == null ? true : !(element == null)))
    return false;
  return this.t3p((element == null ? true : !(element == null)) ? element : THROW_CCE());
};
protoOf(DelegatingMutableSet).u3p = function (elements) {
  return this.l3p_1.v1(this.p3p(elements));
};
protoOf(DelegatingMutableSet).v1 = function (elements) {
  return this.u3p(elements);
};
protoOf(DelegatingMutableSet).p = function () {
  return this.l3p_1.p();
};
protoOf(DelegatingMutableSet).j = function () {
  return new DelegatingMutableSet$iterator$1(this);
};
protoOf(DelegatingMutableSet).hashCode = function () {
  return hashCode(this.l3p_1);
};
protoOf(DelegatingMutableSet).equals = function (other) {
  var tmp;
  if (other == null) {
    tmp = true;
  } else {
    tmp = !(!(other == null) ? isInterface(other, KtSet) : false);
  }
  if (tmp)
    return false;
  var elements = this.q3p(this.l3p_1);
  var tmp_0;
  if (other.v1(elements)) {
    // Inline function 'kotlin.collections.containsAll' call
    tmp_0 = elements.v1(other);
  } else {
    tmp_0 = false;
  }
  return tmp_0;
};
protoOf(DelegatingMutableSet).toString = function () {
  return toString(this.q3p(this.l3p_1));
};
var JsPlatform_Browser_instance;
var JsPlatform_Node_instance;
var JsPlatform_entriesInitialized;
function JsPlatform_initEntries() {
  if (JsPlatform_entriesInitialized)
    return Unit_instance;
  JsPlatform_entriesInitialized = true;
  JsPlatform_Browser_instance = new JsPlatform('Browser', 0);
  JsPlatform_Node_instance = new JsPlatform('Node', 1);
}
function Jvm() {
  Jvm_instance = this;
  Platform.call(this);
}
protoOf(Jvm).toString = function () {
  return 'Jvm';
};
protoOf(Jvm).hashCode = function () {
  return 1051825272;
};
protoOf(Jvm).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Jvm))
    return false;
  other instanceof Jvm || THROW_CCE();
  return true;
};
var Jvm_instance;
function Jvm_getInstance() {
  if (Jvm_instance == null)
    new Jvm();
  return Jvm_instance;
}
function Native() {
  Native_instance = this;
  Platform.call(this);
}
protoOf(Native).toString = function () {
  return 'Native';
};
protoOf(Native).hashCode = function () {
  return -1059277600;
};
protoOf(Native).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Native))
    return false;
  other instanceof Native || THROW_CCE();
  return true;
};
var Native_instance;
function Native_getInstance() {
  if (Native_instance == null)
    new Native();
  return Native_instance;
}
function Js(jsPlatform) {
  Platform.call(this);
  this.v3p_1 = jsPlatform;
}
protoOf(Js).toString = function () {
  return 'Js(jsPlatform=' + this.v3p_1.toString() + ')';
};
protoOf(Js).hashCode = function () {
  return this.v3p_1.hashCode();
};
protoOf(Js).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Js))
    return false;
  var tmp0_other_with_cast = other instanceof Js ? other : THROW_CCE();
  if (!this.v3p_1.equals(tmp0_other_with_cast.v3p_1))
    return false;
  return true;
};
function WasmJs() {
}
function JsPlatform(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function JsPlatform_Browser_getInstance() {
  JsPlatform_initEntries();
  return JsPlatform_Browser_instance;
}
function JsPlatform_Node_getInstance() {
  JsPlatform_initEntries();
  return JsPlatform_Node_instance;
}
function Platform() {
}
function PlatformUtils() {
  PlatformUtils_instance = this;
  var tmp = this;
  var platform = get_platform(this);
  var tmp_0;
  if (platform instanceof Js) {
    tmp_0 = platform.v3p_1.equals(JsPlatform_Browser_getInstance());
  } else {
    if (platform instanceof WasmJs) {
      tmp_0 = platform.w3p_1.equals(JsPlatform_Browser_getInstance());
    } else {
      tmp_0 = false;
    }
  }
  tmp.x3p_1 = tmp_0;
  var tmp_1 = this;
  var platform_0 = get_platform(this);
  var tmp_2;
  if (platform_0 instanceof Js) {
    tmp_2 = platform_0.v3p_1.equals(JsPlatform_Node_getInstance());
  } else {
    if (platform_0 instanceof WasmJs) {
      tmp_2 = platform_0.w3p_1.equals(JsPlatform_Node_getInstance());
    } else {
      tmp_2 = false;
    }
  }
  tmp_1.y3p_1 = tmp_2;
  var tmp_3 = this;
  var tmp_4 = get_platform(this);
  tmp_3.z3p_1 = tmp_4 instanceof Js;
  var tmp_5 = this;
  var tmp_6 = get_platform(this);
  tmp_5.a3q_1 = tmp_6 instanceof WasmJs;
  this.b3q_1 = equals(get_platform(this), Jvm_getInstance());
  this.c3q_1 = equals(get_platform(this), Native_getInstance());
  this.d3q_1 = get_isDevelopmentMode(this);
  this.e3q_1 = true;
}
var PlatformUtils_instance;
function PlatformUtils_getInstance() {
  if (PlatformUtils_instance == null)
    new PlatformUtils();
  return PlatformUtils_instance;
}
function StringValues() {
}
function ensureListForKey($this, name) {
  var tmp0_elvis_lhs = $this.l3q_1.a2(name);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.mutableListOf' call
    // Inline function 'kotlin.also' call
    var this_0 = ArrayList_init_$Create$_0();
    $this.m3q(name);
    // Inline function 'kotlin.collections.set' call
    $this.l3q_1.h2(name, this_0);
    tmp = this_0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
}
function StringValuesBuilderImpl$appendAll$lambda(this$0) {
  return function (name, values) {
    this$0.n3q(name, values);
    return Unit_instance;
  };
}
function StringValuesBuilderImpl(caseInsensitiveName, size) {
  caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
  size = size === VOID ? 8 : size;
  this.k3q_1 = caseInsensitiveName;
  this.l3q_1 = this.k3q_1 ? caseInsensitiveMap() : LinkedHashMap_init_$Create$_0(size);
}
protoOf(StringValuesBuilderImpl).f3q = function () {
  return this.k3q_1;
};
protoOf(StringValuesBuilderImpl).g3q = function (name) {
  return this.l3q_1.a2(name);
};
protoOf(StringValuesBuilderImpl).o3q = function (name) {
  // Inline function 'kotlin.collections.contains' call
  // Inline function 'kotlin.collections.containsKey' call
  var this_0 = this.l3q_1;
  return (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).y1(name);
};
protoOf(StringValuesBuilderImpl).h3q = function () {
  return this.l3q_1.b2();
};
protoOf(StringValuesBuilderImpl).p = function () {
  return this.l3q_1.p();
};
protoOf(StringValuesBuilderImpl).i3q = function () {
  return unmodifiable(this.l3q_1.r());
};
protoOf(StringValuesBuilderImpl).p3q = function (name, value) {
  this.q3q(value);
  var list = ensureListForKey(this, name);
  list.d2();
  list.e(value);
};
protoOf(StringValuesBuilderImpl).h2a = function (name) {
  var tmp0_safe_receiver = this.g3q(name);
  return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
};
protoOf(StringValuesBuilderImpl).r3q = function (name, value) {
  this.q3q(value);
  ensureListForKey(this, name).e(value);
};
protoOf(StringValuesBuilderImpl).s3q = function (stringValues) {
  stringValues.j3q(StringValuesBuilderImpl$appendAll$lambda(this));
};
protoOf(StringValuesBuilderImpl).n3q = function (name, values) {
  // Inline function 'kotlin.let' call
  var list = ensureListForKey(this, name);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = values.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    this.q3q(element);
  }
  addAll(list, values);
};
protoOf(StringValuesBuilderImpl).t3q = function (name, values) {
  var tmp0_safe_receiver = this.l3q_1.a2(name);
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : toSet(tmp0_safe_receiver);
  var existing = tmp1_elvis_lhs == null ? emptySet() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = values.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!existing.u1(element)) {
      destination.e(element);
    }
  }
  this.n3q(name, destination);
};
protoOf(StringValuesBuilderImpl).u3q = function (name) {
  this.l3q_1.i2(name);
};
protoOf(StringValuesBuilderImpl).d2 = function () {
  this.l3q_1.d2();
};
protoOf(StringValuesBuilderImpl).m3q = function (name) {
};
protoOf(StringValuesBuilderImpl).q3q = function (value) {
};
function listForKey($this, name) {
  return $this.w3q_1.a2(name);
}
function StringValuesImpl(caseInsensitiveName, values) {
  caseInsensitiveName = caseInsensitiveName === VOID ? false : caseInsensitiveName;
  values = values === VOID ? emptyMap() : values;
  this.v3q_1 = caseInsensitiveName;
  var tmp;
  if (this.v3q_1) {
    tmp = caseInsensitiveMap();
  } else {
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp = LinkedHashMap_init_$Create$();
  }
  var newMap = tmp;
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = values.r().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = element.s();
    // Inline function 'kotlin.collections.component2' call
    var value = element.t();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = value.m();
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4 = value.o(index);
        list.e(tmp$ret$4);
      }
       while (inductionVariable < size);
    // Inline function 'kotlin.collections.set' call
    newMap.h2(key, list);
  }
  this.w3q_1 = newMap;
}
protoOf(StringValuesImpl).f3q = function () {
  return this.v3q_1;
};
protoOf(StringValuesImpl).h2a = function (name) {
  var tmp0_safe_receiver = listForKey(this, name);
  return tmp0_safe_receiver == null ? null : firstOrNull(tmp0_safe_receiver);
};
protoOf(StringValuesImpl).g3q = function (name) {
  return listForKey(this, name);
};
protoOf(StringValuesImpl).h3q = function () {
  return unmodifiable(this.w3q_1.b2());
};
protoOf(StringValuesImpl).p = function () {
  return this.w3q_1.p();
};
protoOf(StringValuesImpl).i3q = function () {
  return unmodifiable(this.w3q_1.r());
};
protoOf(StringValuesImpl).j3q = function (body) {
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this.w3q_1.r().j();
  while (_iterator__ex2g4s.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.s();
    // Inline function 'kotlin.collections.component2' call
    var value = _destruct__k2r9zo.t();
    body(key, value);
  }
};
protoOf(StringValuesImpl).toString = function () {
  return 'StringValues(case=' + !this.v3q_1 + ') ' + toString(this.i3q());
};
protoOf(StringValuesImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(!(other == null) ? isInterface(other, StringValues) : false))
    return false;
  if (!(this.v3q_1 === other.f3q()))
    return false;
  return entriesEquals(this.i3q(), other.i3q());
};
protoOf(StringValuesImpl).hashCode = function () {
  return entriesHashCode(this.i3q(), imul(31, getBooleanHashCode(this.v3q_1)));
};
function appendAll(_this__u8e3s4, builder) {
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = builder.i3q().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var name = element.s();
    // Inline function 'kotlin.collections.component2' call
    var values = element.t();
    _this__u8e3s4.n3q(name, values);
  }
  return _this__u8e3s4;
}
function appendIfNameAbsent(_this__u8e3s4, name, value) {
  // Inline function 'kotlin.apply' call
  $l$block: {
    if (_this__u8e3s4.o3q(name)) {
      break $l$block;
    }
    _this__u8e3s4.r3q(name, value);
  }
  return _this__u8e3s4;
}
function entriesEquals(a, b) {
  return equals(a, b);
}
function entriesHashCode(entries, seed) {
  return imul(seed, 31) + hashCode(entries) | 0;
}
function StringValuesSingleImpl$entries$1(this$0) {
  this.x3q_1 = this$0.a3r_1;
  this.y3q_1 = this$0.b3r_1;
}
protoOf(StringValuesSingleImpl$entries$1).s = function () {
  return this.x3q_1;
};
protoOf(StringValuesSingleImpl$entries$1).t = function () {
  return this.y3q_1;
};
protoOf(StringValuesSingleImpl$entries$1).toString = function () {
  return this.x3q_1 + '=' + toString(this.y3q_1);
};
protoOf(StringValuesSingleImpl$entries$1).equals = function (other) {
  var tmp;
  var tmp_0;
  if (!(other == null) ? isInterface(other, Entry) : false) {
    tmp_0 = equals(other.s(), this.x3q_1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = equals(other.t(), this.y3q_1);
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(StringValuesSingleImpl$entries$1).hashCode = function () {
  return getStringHashCode(this.x3q_1) ^ hashCode(this.y3q_1);
};
function StringValuesSingleImpl(caseInsensitiveName, name, values) {
  this.z3q_1 = caseInsensitiveName;
  this.a3r_1 = name;
  this.b3r_1 = values;
}
protoOf(StringValuesSingleImpl).f3q = function () {
  return this.z3q_1;
};
protoOf(StringValuesSingleImpl).g3q = function (name) {
  return equals_0(this.a3r_1, name, this.f3q()) ? this.b3r_1 : null;
};
protoOf(StringValuesSingleImpl).i3q = function () {
  return setOf(new StringValuesSingleImpl$entries$1(this));
};
protoOf(StringValuesSingleImpl).h3q = function () {
  return setOf(this.a3r_1);
};
protoOf(StringValuesSingleImpl).toString = function () {
  return 'StringValues(case=' + !this.f3q() + ') ' + toString(this.i3q());
};
protoOf(StringValuesSingleImpl).hashCode = function () {
  return entriesHashCode(this.i3q(), imul(31, getBooleanHashCode(this.f3q())));
};
protoOf(StringValuesSingleImpl).equals = function (other) {
  if (this === other)
    return true;
  if (!(!(other == null) ? isInterface(other, StringValues) : false))
    return false;
  if (!(this.f3q() === other.f3q()))
    return false;
  return entriesEquals(this.i3q(), other.i3q());
};
protoOf(StringValuesSingleImpl).j3q = function (body) {
  return body(this.a3r_1, this.b3r_1);
};
protoOf(StringValuesSingleImpl).h2a = function (name) {
  return equals_0(name, this.a3r_1, this.f3q()) ? firstOrNull(this.b3r_1) : null;
};
function toLowerCasePreservingASCIIRules(_this__u8e3s4) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.text.indexOfFirst' call
    var inductionVariable = 0;
    var last = charSequenceLength(_this__u8e3s4) - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = charSequenceGet(_this__u8e3s4, index);
        if (!(toLowerCasePreservingASCII(it) === it)) {
          tmp$ret$1 = index;
          break $l$block;
        }
      }
       while (inductionVariable <= last);
    tmp$ret$1 = -1;
  }
  var firstIndex = tmp$ret$1;
  if (firstIndex === -1) {
    return _this__u8e3s4;
  }
  var original = _this__u8e3s4;
  // Inline function 'kotlin.text.buildString' call
  var capacity = _this__u8e3s4.length;
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder_init_$Create$(capacity);
  this_0.fc(original, 0, firstIndex);
  var inductionVariable_0 = firstIndex;
  var last_0 = get_lastIndex(original);
  if (inductionVariable_0 <= last_0)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      this_0.c8(toLowerCasePreservingASCII(charSequenceGet(original, index_0)));
    }
     while (!(index_0 === last_0));
  return this_0.toString();
}
function toLowerCasePreservingASCII(ch) {
  var tmp;
  if (_Char___init__impl__6a9atx(65) <= ch ? ch <= _Char___init__impl__6a9atx(90) : false) {
    tmp = Char__plus_impl_qi7pgj(ch, 32);
  } else if (_Char___init__impl__6a9atx(0) <= ch ? ch <= _Char___init__impl__6a9atx(127) : false) {
    tmp = ch;
  } else {
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = toString_1(ch).toLowerCase();
    tmp = charSequenceGet(tmp$ret$2, 0);
  }
  return tmp;
}
function CaseInsensitiveString(content) {
  this.z3o_1 = content;
  var temp = 0;
  var indexedObject = this.z3o_1;
  var inductionVariable = 0;
  var last = indexedObject.length;
  while (inductionVariable < last) {
    var element = charSequenceGet(indexedObject, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    var tmp = imul(temp, 31);
    // Inline function 'kotlin.text.lowercaseChar' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.js.unsafeCast' call
    var tmp$ret$2 = toString_1(element).toLowerCase();
    // Inline function 'kotlin.code' call
    var this_0 = charSequenceGet(tmp$ret$2, 0);
    temp = tmp + Char__toInt_impl_vasixd(this_0) | 0;
  }
  this.a3p_1 = temp;
}
protoOf(CaseInsensitiveString).equals = function (other) {
  var tmp0_safe_receiver = other instanceof CaseInsensitiveString ? other : null;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.z3o_1;
  return (tmp1_safe_receiver == null ? null : equals_0(tmp1_safe_receiver, this.z3o_1, true)) === true;
};
protoOf(CaseInsensitiveString).hashCode = function () {
  return this.a3p_1;
};
protoOf(CaseInsensitiveString).toString = function () {
  return this.z3o_1;
};
function caseInsensitive(_this__u8e3s4) {
  return new CaseInsensitiveString(_this__u8e3s4);
}
function ChannelIOException() {
}
function CopyOnWriteHashMap() {
  this.c3r_1 = atomic$ref$1(emptyMap());
}
protoOf(CopyOnWriteHashMap).d3r = function (key) {
  return this.c3r_1.kotlinx$atomicfu$value.a2(key);
};
function GMTDate$Companion$$childSerializers$_anonymous__gyfycy() {
  return createSimpleEnumSerializer('io.ktor.util.date.WeekDay', values());
}
function GMTDate$Companion$$childSerializers$_anonymous__gyfycy_0() {
  return createSimpleEnumSerializer('io.ktor.util.date.Month', values_0());
}
function Companion() {
  Companion_instance_0 = this;
  var tmp = this;
  var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  var tmp_1 = lazy(tmp_0, GMTDate$Companion$$childSerializers$_anonymous__gyfycy);
  var tmp_2 = LazyThreadSafetyMode_PUBLICATION_getInstance();
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  tmp.e3r_1 = [null, null, null, tmp_1, null, null, lazy(tmp_2, GMTDate$Companion$$childSerializers$_anonymous__gyfycy_0), null, null];
  this.f3r_1 = GMTDate_0(new Long(0, 0));
}
var Companion_instance_0;
function Companion_getInstance() {
  if (Companion_instance_0 == null)
    new Companion();
  return Companion_instance_0;
}
function $serializer() {
  $serializer_instance = this;
  var tmp0_serialDesc = new PluginGeneratedSerialDescriptor('io.ktor.util.date.GMTDate', this, 9);
  tmp0_serialDesc.wy('seconds', false);
  tmp0_serialDesc.wy('minutes', false);
  tmp0_serialDesc.wy('hours', false);
  tmp0_serialDesc.wy('dayOfWeek', false);
  tmp0_serialDesc.wy('dayOfMonth', false);
  tmp0_serialDesc.wy('dayOfYear', false);
  tmp0_serialDesc.wy('month', false);
  tmp0_serialDesc.wy('year', false);
  tmp0_serialDesc.wy('timestamp', false);
  this.g3r_1 = tmp0_serialDesc;
}
protoOf($serializer).h3r = function (encoder, value) {
  var tmp0_desc = this.g3r_1;
  var tmp1_output = encoder.kr(tmp0_desc);
  var tmp2_cached = Companion_getInstance().e3r_1;
  tmp1_output.us(tmp0_desc, 0, value.i3r_1);
  tmp1_output.us(tmp0_desc, 1, value.j3r_1);
  tmp1_output.us(tmp0_desc, 2, value.k3r_1);
  tmp1_output.bt(tmp0_desc, 3, tmp2_cached[3].t(), value.l3r_1);
  tmp1_output.us(tmp0_desc, 4, value.m3r_1);
  tmp1_output.us(tmp0_desc, 5, value.n3r_1);
  tmp1_output.bt(tmp0_desc, 6, tmp2_cached[6].t(), value.o3r_1);
  tmp1_output.us(tmp0_desc, 7, value.p3r_1);
  tmp1_output.vs(tmp0_desc, 8, value.q3r_1);
  tmp1_output.lr(tmp0_desc);
};
protoOf($serializer).yn = function (encoder, value) {
  return this.h3r(encoder, value instanceof GMTDate ? value : THROW_CCE());
};
protoOf($serializer).zn = function (decoder) {
  var tmp0_desc = this.g3r_1;
  var tmp1_flag = true;
  var tmp2_index = 0;
  var tmp3_bitMask0 = 0;
  var tmp4_local0 = 0;
  var tmp5_local1 = 0;
  var tmp6_local2 = 0;
  var tmp7_local3 = null;
  var tmp8_local4 = 0;
  var tmp9_local5 = 0;
  var tmp10_local6 = null;
  var tmp11_local7 = 0;
  var tmp12_local8 = new Long(0, 0);
  var tmp13_input = decoder.kr(tmp0_desc);
  var tmp14_cached = Companion_getInstance().e3r_1;
  if (tmp13_input.as()) {
    tmp4_local0 = tmp13_input.pr(tmp0_desc, 0);
    tmp3_bitMask0 = tmp3_bitMask0 | 1;
    tmp5_local1 = tmp13_input.pr(tmp0_desc, 1);
    tmp3_bitMask0 = tmp3_bitMask0 | 2;
    tmp6_local2 = tmp13_input.pr(tmp0_desc, 2);
    tmp3_bitMask0 = tmp3_bitMask0 | 4;
    tmp7_local3 = tmp13_input.wr(tmp0_desc, 3, tmp14_cached[3].t(), tmp7_local3);
    tmp3_bitMask0 = tmp3_bitMask0 | 8;
    tmp8_local4 = tmp13_input.pr(tmp0_desc, 4);
    tmp3_bitMask0 = tmp3_bitMask0 | 16;
    tmp9_local5 = tmp13_input.pr(tmp0_desc, 5);
    tmp3_bitMask0 = tmp3_bitMask0 | 32;
    tmp10_local6 = tmp13_input.wr(tmp0_desc, 6, tmp14_cached[6].t(), tmp10_local6);
    tmp3_bitMask0 = tmp3_bitMask0 | 64;
    tmp11_local7 = tmp13_input.pr(tmp0_desc, 7);
    tmp3_bitMask0 = tmp3_bitMask0 | 128;
    tmp12_local8 = tmp13_input.qr(tmp0_desc, 8);
    tmp3_bitMask0 = tmp3_bitMask0 | 256;
  } else
    while (tmp1_flag) {
      tmp2_index = tmp13_input.bs(tmp0_desc);
      switch (tmp2_index) {
        case -1:
          tmp1_flag = false;
          break;
        case 0:
          tmp4_local0 = tmp13_input.pr(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          break;
        case 1:
          tmp5_local1 = tmp13_input.pr(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          break;
        case 2:
          tmp6_local2 = tmp13_input.pr(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          break;
        case 3:
          tmp7_local3 = tmp13_input.wr(tmp0_desc, 3, tmp14_cached[3].t(), tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          break;
        case 4:
          tmp8_local4 = tmp13_input.pr(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          break;
        case 5:
          tmp9_local5 = tmp13_input.pr(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          break;
        case 6:
          tmp10_local6 = tmp13_input.wr(tmp0_desc, 6, tmp14_cached[6].t(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          break;
        case 7:
          tmp11_local7 = tmp13_input.pr(tmp0_desc, 7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          break;
        case 8:
          tmp12_local8 = tmp13_input.qr(tmp0_desc, 8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          break;
        default:
          throw UnknownFieldException_init_$Create$(tmp2_index);
      }
    }
  tmp13_input.lr(tmp0_desc);
  return GMTDate_init_$Create$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, null);
};
protoOf($serializer).xn = function () {
  return this.g3r_1;
};
protoOf($serializer).pz = function () {
  var tmp0_cached = Companion_getInstance().e3r_1;
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return [IntSerializer_getInstance(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[3].t(), IntSerializer_getInstance(), IntSerializer_getInstance(), tmp0_cached[6].t(), IntSerializer_getInstance(), LongSerializer_getInstance()];
};
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance == null)
    new $serializer();
  return $serializer_instance;
}
function GMTDate_init_$Init$(seen0, seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp, serializationConstructorMarker, $this) {
  if (!(511 === (511 & seen0))) {
    throwMissingFieldException(seen0, 511, $serializer_getInstance().g3r_1);
  }
  $this.i3r_1 = seconds;
  $this.j3r_1 = minutes;
  $this.k3r_1 = hours;
  $this.l3r_1 = dayOfWeek;
  $this.m3r_1 = dayOfMonth;
  $this.n3r_1 = dayOfYear;
  $this.o3r_1 = month;
  $this.p3r_1 = year;
  $this.q3r_1 = timestamp;
  return $this;
}
function GMTDate_init_$Create$(seen0, seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp, serializationConstructorMarker) {
  return GMTDate_init_$Init$(seen0, seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp, serializationConstructorMarker, objectCreate(protoOf(GMTDate)));
}
function GMTDate(seconds, minutes, hours, dayOfWeek, dayOfMonth, dayOfYear, month, year, timestamp) {
  Companion_getInstance();
  this.i3r_1 = seconds;
  this.j3r_1 = minutes;
  this.k3r_1 = hours;
  this.l3r_1 = dayOfWeek;
  this.m3r_1 = dayOfMonth;
  this.n3r_1 = dayOfYear;
  this.o3r_1 = month;
  this.p3r_1 = year;
  this.q3r_1 = timestamp;
}
protoOf(GMTDate).r3r = function (other) {
  return this.q3r_1.b1(other.q3r_1);
};
protoOf(GMTDate).d = function (other) {
  return this.r3r(other instanceof GMTDate ? other : THROW_CCE());
};
protoOf(GMTDate).toString = function () {
  return 'GMTDate(seconds=' + this.i3r_1 + ', minutes=' + this.j3r_1 + ', hours=' + this.k3r_1 + ', dayOfWeek=' + this.l3r_1.toString() + ', dayOfMonth=' + this.m3r_1 + ', dayOfYear=' + this.n3r_1 + ', month=' + this.o3r_1.toString() + ', year=' + this.p3r_1 + ', timestamp=' + this.q3r_1.toString() + ')';
};
protoOf(GMTDate).hashCode = function () {
  var result = this.i3r_1;
  result = imul(result, 31) + this.j3r_1 | 0;
  result = imul(result, 31) + this.k3r_1 | 0;
  result = imul(result, 31) + this.l3r_1.hashCode() | 0;
  result = imul(result, 31) + this.m3r_1 | 0;
  result = imul(result, 31) + this.n3r_1 | 0;
  result = imul(result, 31) + this.o3r_1.hashCode() | 0;
  result = imul(result, 31) + this.p3r_1 | 0;
  result = imul(result, 31) + this.q3r_1.hashCode() | 0;
  return result;
};
protoOf(GMTDate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GMTDate))
    return false;
  var tmp0_other_with_cast = other instanceof GMTDate ? other : THROW_CCE();
  if (!(this.i3r_1 === tmp0_other_with_cast.i3r_1))
    return false;
  if (!(this.j3r_1 === tmp0_other_with_cast.j3r_1))
    return false;
  if (!(this.k3r_1 === tmp0_other_with_cast.k3r_1))
    return false;
  if (!this.l3r_1.equals(tmp0_other_with_cast.l3r_1))
    return false;
  if (!(this.m3r_1 === tmp0_other_with_cast.m3r_1))
    return false;
  if (!(this.n3r_1 === tmp0_other_with_cast.n3r_1))
    return false;
  if (!this.o3r_1.equals(tmp0_other_with_cast.o3r_1))
    return false;
  if (!(this.p3r_1 === tmp0_other_with_cast.p3r_1))
    return false;
  if (!this.q3r_1.equals(tmp0_other_with_cast.q3r_1))
    return false;
  return true;
};
var WeekDay_MONDAY_instance;
var WeekDay_TUESDAY_instance;
var WeekDay_WEDNESDAY_instance;
var WeekDay_THURSDAY_instance;
var WeekDay_FRIDAY_instance;
var WeekDay_SATURDAY_instance;
var WeekDay_SUNDAY_instance;
function Companion_0() {
}
protoOf(Companion_0).s3r = function (ordinal) {
  return get_entries().o(ordinal);
};
var Companion_instance_1;
function Companion_getInstance_0() {
  return Companion_instance_1;
}
function values() {
  return [WeekDay_MONDAY_getInstance(), WeekDay_TUESDAY_getInstance(), WeekDay_WEDNESDAY_getInstance(), WeekDay_THURSDAY_getInstance(), WeekDay_FRIDAY_getInstance(), WeekDay_SATURDAY_getInstance(), WeekDay_SUNDAY_getInstance()];
}
function get_entries() {
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var WeekDay_entriesInitialized;
function WeekDay_initEntries() {
  if (WeekDay_entriesInitialized)
    return Unit_instance;
  WeekDay_entriesInitialized = true;
  WeekDay_MONDAY_instance = new WeekDay('MONDAY', 0, 'Mon');
  WeekDay_TUESDAY_instance = new WeekDay('TUESDAY', 1, 'Tue');
  WeekDay_WEDNESDAY_instance = new WeekDay('WEDNESDAY', 2, 'Wed');
  WeekDay_THURSDAY_instance = new WeekDay('THURSDAY', 3, 'Thu');
  WeekDay_FRIDAY_instance = new WeekDay('FRIDAY', 4, 'Fri');
  WeekDay_SATURDAY_instance = new WeekDay('SATURDAY', 5, 'Sat');
  WeekDay_SUNDAY_instance = new WeekDay('SUNDAY', 6, 'Sun');
}
var $ENTRIES;
function WeekDay(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.v3r_1 = value;
}
var Month_JANUARY_instance;
var Month_FEBRUARY_instance;
var Month_MARCH_instance;
var Month_APRIL_instance;
var Month_MAY_instance;
var Month_JUNE_instance;
var Month_JULY_instance;
var Month_AUGUST_instance;
var Month_SEPTEMBER_instance;
var Month_OCTOBER_instance;
var Month_NOVEMBER_instance;
var Month_DECEMBER_instance;
function Companion_1() {
}
protoOf(Companion_1).s3r = function (ordinal) {
  return get_entries_0().o(ordinal);
};
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
function values_0() {
  return [Month_JANUARY_getInstance(), Month_FEBRUARY_getInstance(), Month_MARCH_getInstance(), Month_APRIL_getInstance(), Month_MAY_getInstance(), Month_JUNE_getInstance(), Month_JULY_getInstance(), Month_AUGUST_getInstance(), Month_SEPTEMBER_getInstance(), Month_OCTOBER_getInstance(), Month_NOVEMBER_getInstance(), Month_DECEMBER_getInstance()];
}
function get_entries_0() {
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var Month_entriesInitialized;
function Month_initEntries() {
  if (Month_entriesInitialized)
    return Unit_instance;
  Month_entriesInitialized = true;
  Month_JANUARY_instance = new Month('JANUARY', 0, 'Jan');
  Month_FEBRUARY_instance = new Month('FEBRUARY', 1, 'Feb');
  Month_MARCH_instance = new Month('MARCH', 2, 'Mar');
  Month_APRIL_instance = new Month('APRIL', 3, 'Apr');
  Month_MAY_instance = new Month('MAY', 4, 'May');
  Month_JUNE_instance = new Month('JUNE', 5, 'Jun');
  Month_JULY_instance = new Month('JULY', 6, 'Jul');
  Month_AUGUST_instance = new Month('AUGUST', 7, 'Aug');
  Month_SEPTEMBER_instance = new Month('SEPTEMBER', 8, 'Sep');
  Month_OCTOBER_instance = new Month('OCTOBER', 9, 'Oct');
  Month_NOVEMBER_instance = new Month('NOVEMBER', 10, 'Nov');
  Month_DECEMBER_instance = new Month('DECEMBER', 11, 'Dec');
}
var $ENTRIES_0;
function Month(name, ordinal, value) {
  Enum.call(this, name, ordinal);
  this.y3r_1 = value;
}
function WeekDay_MONDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_MONDAY_instance;
}
function WeekDay_TUESDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_TUESDAY_instance;
}
function WeekDay_WEDNESDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_WEDNESDAY_instance;
}
function WeekDay_THURSDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_THURSDAY_instance;
}
function WeekDay_FRIDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_FRIDAY_instance;
}
function WeekDay_SATURDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_SATURDAY_instance;
}
function WeekDay_SUNDAY_getInstance() {
  WeekDay_initEntries();
  return WeekDay_SUNDAY_instance;
}
function Month_JANUARY_getInstance() {
  Month_initEntries();
  return Month_JANUARY_instance;
}
function Month_FEBRUARY_getInstance() {
  Month_initEntries();
  return Month_FEBRUARY_instance;
}
function Month_MARCH_getInstance() {
  Month_initEntries();
  return Month_MARCH_instance;
}
function Month_APRIL_getInstance() {
  Month_initEntries();
  return Month_APRIL_instance;
}
function Month_MAY_getInstance() {
  Month_initEntries();
  return Month_MAY_instance;
}
function Month_JUNE_getInstance() {
  Month_initEntries();
  return Month_JUNE_instance;
}
function Month_JULY_getInstance() {
  Month_initEntries();
  return Month_JULY_instance;
}
function Month_AUGUST_getInstance() {
  Month_initEntries();
  return Month_AUGUST_instance;
}
function Month_SEPTEMBER_getInstance() {
  Month_initEntries();
  return Month_SEPTEMBER_instance;
}
function Month_OCTOBER_getInstance() {
  Month_initEntries();
  return Month_OCTOBER_instance;
}
function Month_NOVEMBER_getInstance() {
  Month_initEntries();
  return Month_NOVEMBER_instance;
}
function Month_DECEMBER_getInstance() {
  Month_initEntries();
  return Month_DECEMBER_instance;
}
var CONDITION_FALSE;
var ALREADY_REMOVED;
var LIST_EMPTY;
var REMOVE_PREPARED;
var NO_DECISION;
function Symbol(symbol) {
  this.z3r_1 = symbol;
}
protoOf(Symbol).toString = function () {
  return this.z3r_1;
};
function LockFreeLinkedListNode() {
}
protoOf(LockFreeLinkedListNode).r1r = function () {
  // Inline function 'kotlinx.atomicfu.loop' call
  var this_0 = this.a3s_1;
  while (true) {
    var next = this_0.kotlinx$atomicfu$value;
    if (!(next instanceof OpDescriptor))
      return next;
    next.b3s(this);
  }
};
protoOf(LockFreeLinkedListNode).c3s = function () {
  return unwrap(this.r1r());
};
function Removed() {
}
function OpDescriptor() {
}
function unwrap(_this__u8e3s4) {
  _init_properties_LockFreeLinkedList_kt__wekxce();
  var tmp0_safe_receiver = _this__u8e3s4 instanceof Removed ? _this__u8e3s4 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d3s_1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    tmp = _this__u8e3s4 instanceof LockFreeLinkedListNode ? _this__u8e3s4 : THROW_CCE();
  } else {
    tmp = tmp1_elvis_lhs;
  }
  return tmp;
}
var properties_initialized_LockFreeLinkedList_kt_lnmdgw;
function _init_properties_LockFreeLinkedList_kt__wekxce() {
  if (!properties_initialized_LockFreeLinkedList_kt_lnmdgw) {
    properties_initialized_LockFreeLinkedList_kt_lnmdgw = true;
    CONDITION_FALSE = new Symbol('CONDITION_FALSE');
    ALREADY_REMOVED = new Symbol('ALREADY_REMOVED');
    LIST_EMPTY = new Symbol('LIST_EMPTY');
    REMOVE_PREPARED = new Symbol('REMOVE_PREPARED');
    NO_DECISION = new Symbol('NO_DECISION');
  }
}
function proceedLoop($this, $completion) {
  var tmp = new $proceedLoopCOROUTINE$0($this, $completion);
  tmp.p8_1 = Unit_instance;
  tmp.q8_1 = null;
  return tmp.v8();
}
function $proceedLoopCOROUTINE$0(_this__u8e3s4, resultContinuation) {
  CoroutineImpl.call(this, resultContinuation);
  this.m3s_1 = _this__u8e3s4;
}
protoOf($proceedLoopCOROUTINE$0).v8 = function () {
  var suspendResult = this.p8_1;
  $sm: do
    try {
      var tmp = this.n8_1;
      switch (tmp) {
        case 0:
          this.o8_1 = 6;
          this.n8_1 = 1;
          continue $sm;
        case 1:
          this.n3s_1 = this.m3s_1.u3s_1;
          if (this.n3s_1 === -1) {
            this.n8_1 = 5;
            continue $sm;
          } else {
            this.n8_1 = 2;
            continue $sm;
          }

        case 2:
          this.o3s_1 = this.m3s_1.r3s_1;
          if (this.n3s_1 >= this.o3s_1.m()) {
            this.m3s_1.v3s();
            this.n8_1 = 5;
            continue $sm;
          } else {
            this.n8_1 = 3;
            continue $sm;
          }

        case 3:
          this.p3s_1 = this.o3s_1.o(this.n3s_1);
          this.m3s_1.u3s_1 = this.n3s_1 + 1 | 0;
          this.n8_1 = 4;
          suspendResult = this.p3s_1(this.m3s_1, this.m3s_1.t3s_1, this);
          if (suspendResult === get_COROUTINE_SUSPENDED()) {
            return suspendResult;
          }

          continue $sm;
        case 4:
          this.n8_1 = 1;
          continue $sm;
        case 5:
          return this.m3s_1.t3s_1;
        case 6:
          throw this.q8_1;
      }
    } catch ($p) {
      var e = $p;
      if (this.o8_1 === 6) {
        throw e;
      } else {
        this.n8_1 = this.o8_1;
        this.q8_1 = e;
      }
    }
   while (true);
};
function DebugPipelineContext(context, interceptors, subject, coroutineContext) {
  PipelineContext.call(this, context);
  this.r3s_1 = interceptors;
  this.s3s_1 = coroutineContext;
  this.t3s_1 = subject;
  this.u3s_1 = 0;
}
protoOf(DebugPipelineContext).h1e = function () {
  return this.s3s_1;
};
protoOf(DebugPipelineContext).w3s = function () {
  return this.t3s_1;
};
protoOf(DebugPipelineContext).v3s = function () {
  this.u3s_1 = -1;
};
protoOf(DebugPipelineContext).x3s = function (subject, $completion) {
  this.t3s_1 = subject;
  return this.y3s($completion);
};
protoOf(DebugPipelineContext).y3s = function ($completion) {
  var index = this.u3s_1;
  if (index < 0)
    return this.t3s_1;
  if (index >= this.r3s_1.m()) {
    this.v3s();
    return this.t3s_1;
  }
  return proceedLoop(this, $completion);
};
protoOf(DebugPipelineContext).z3s = function (initial, $completion) {
  this.u3s_1 = 0;
  this.t3s_1 = initial;
  return this.y3s($completion);
};
function PhaseContent_init_$Init$(phase, relation, $this) {
  var tmp = Companion_getInstance_2().a3t_1;
  PhaseContent.call($this, phase, relation, isInterface(tmp, KtMutableList) ? tmp : THROW_CCE());
  // Inline function 'kotlin.check' call
  if (!Companion_getInstance_2().a3t_1.p()) {
    var message = 'The shared empty array list has been modified';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  return $this;
}
function PhaseContent_init_$Create$(phase, relation) {
  return PhaseContent_init_$Init$(phase, relation, objectCreate(protoOf(PhaseContent)));
}
function copiedInterceptors($this) {
  return toMutableList($this.d3t_1);
}
function copyInterceptors($this) {
  $this.d3t_1 = copiedInterceptors($this);
  $this.e3t_1 = false;
}
function Companion_2() {
  Companion_instance_3 = this;
  var tmp = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp.a3t_1 = ArrayList_init_$Create$_0();
}
var Companion_instance_3;
function Companion_getInstance_2() {
  if (Companion_instance_3 == null)
    new Companion_2();
  return Companion_instance_3;
}
function PhaseContent(phase, relation, interceptors) {
  Companion_getInstance_2();
  this.b3t_1 = phase;
  this.c3t_1 = relation;
  this.d3t_1 = interceptors;
  this.e3t_1 = true;
}
protoOf(PhaseContent).f3t = function () {
  return this.d3t_1.p();
};
protoOf(PhaseContent).m = function () {
  return this.d3t_1.m();
};
protoOf(PhaseContent).g3t = function (interceptor) {
  if (this.e3t_1) {
    copyInterceptors(this);
  }
  this.d3t_1.e(interceptor);
};
protoOf(PhaseContent).h3t = function (destination) {
  var interceptors = this.d3t_1;
  if (destination instanceof ArrayList) {
    destination.k5(destination.m() + interceptors.m() | 0);
  }
  var inductionVariable = 0;
  var last = interceptors.m();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      destination.e(interceptors.o(index));
    }
     while (inductionVariable < last);
};
protoOf(PhaseContent).i3t = function () {
  this.e3t_1 = true;
  return this.d3t_1;
};
protoOf(PhaseContent).toString = function () {
  return 'Phase `' + this.b3t_1.j3t_1 + '`, ' + this.m() + ' handlers';
};
function _set_interceptors__wod97b($this, _set____db54di) {
  var tmp0 = $this.o3t_1;
  // Inline function 'kotlinx.atomicfu.AtomicRef.setValue' call
  interceptors$factory();
  tmp0.kotlinx$atomicfu$value = _set____db54di;
  return Unit_instance;
}
function _get_interceptors__h4min7($this) {
  var tmp0 = $this.o3t_1;
  // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
  interceptors$factory_0();
  return tmp0.kotlinx$atomicfu$value;
}
function createContext($this, context, subject, coroutineContext) {
  return pipelineContextFor(context, sharedInterceptorsList($this), subject, coroutineContext, $this.r3t());
}
function findPhase($this, phase) {
  var phasesList = $this.m3t_1;
  var inductionVariable = 0;
  var last = phasesList.m();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.o(index);
      if (current === phase) {
        var content = PhaseContent_init_$Create$(phase, Last_getInstance());
        phasesList.e2(index, content);
        return content;
      }
      var tmp;
      if (current instanceof PhaseContent) {
        tmp = current.b3t_1 === phase;
      } else {
        tmp = false;
      }
      if (tmp) {
        return current instanceof PhaseContent ? current : THROW_CCE();
      }
    }
     while (inductionVariable < last);
  return null;
}
function findPhaseIndex($this, phase) {
  var phasesList = $this.m3t_1;
  var inductionVariable = 0;
  var last = phasesList.m();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.o(index);
      var tmp;
      if (current === phase) {
        tmp = true;
      } else {
        var tmp_0;
        if (current instanceof PhaseContent) {
          tmp_0 = current.b3t_1 === phase;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return index;
      }
    }
     while (inductionVariable < last);
  return -1;
}
function hasPhase($this, phase) {
  var phasesList = $this.m3t_1;
  var inductionVariable = 0;
  var last = phasesList.m();
  if (inductionVariable < last)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var current = phasesList.o(index);
      var tmp;
      if (current === phase) {
        tmp = true;
      } else {
        var tmp_0;
        if (current instanceof PhaseContent) {
          tmp_0 = current.b3t_1 === phase;
        } else {
          tmp_0 = false;
        }
        tmp = tmp_0;
      }
      if (tmp) {
        return true;
      }
    }
     while (inductionVariable < last);
  return false;
}
function cacheInterceptors($this) {
  var interceptorsQuantity = $this.n3t_1;
  if (interceptorsQuantity === 0) {
    notSharedInterceptorsList($this, emptyList());
    return emptyList();
  }
  var phases = $this.m3t_1;
  if (interceptorsQuantity === 1) {
    var inductionVariable = 0;
    var last = get_lastIndex_0(phases);
    if (inductionVariable <= last)
      $l$loop_0: do {
        var phaseIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = phases.o(phaseIndex);
        var tmp0_elvis_lhs = tmp instanceof PhaseContent ? tmp : null;
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        var phaseContent = tmp_0;
        if (phaseContent.f3t())
          continue $l$loop_0;
        var interceptors = phaseContent.i3t();
        setInterceptorsListFromPhase($this, phaseContent);
        return interceptors;
      }
       while (!(phaseIndex === last));
  }
  // Inline function 'kotlin.collections.mutableListOf' call
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable_0 = 0;
  var last_0 = get_lastIndex_0(phases);
  if (inductionVariable_0 <= last_0)
    $l$loop_1: do {
      var phaseIndex_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp_1 = phases.o(phaseIndex_0);
      var tmp1_elvis_lhs = tmp_1 instanceof PhaseContent ? tmp_1 : null;
      var tmp_2;
      if (tmp1_elvis_lhs == null) {
        continue $l$loop_1;
      } else {
        tmp_2 = tmp1_elvis_lhs;
      }
      var phase = tmp_2;
      phase.h3t(destination);
    }
     while (!(phaseIndex_0 === last_0));
  notSharedInterceptorsList($this, destination);
  return destination;
}
function sharedInterceptorsList($this) {
  if (_get_interceptors__h4min7($this) == null) {
    cacheInterceptors($this);
  }
  $this.p3t_1 = true;
  return ensureNotNull(_get_interceptors__h4min7($this));
}
function resetInterceptorsList($this) {
  _set_interceptors__wod97b($this, null);
  $this.p3t_1 = false;
  $this.q3t_1 = null;
}
function notSharedInterceptorsList($this, list) {
  _set_interceptors__wod97b($this, list);
  $this.p3t_1 = false;
  $this.q3t_1 = null;
}
function setInterceptorsListFromPhase($this, phaseContent) {
  _set_interceptors__wod97b($this, phaseContent.i3t());
  $this.p3t_1 = false;
  $this.q3t_1 = phaseContent.b3t_1;
}
function tryAddToPhaseFastPath($this, phase, block) {
  var currentInterceptors = _get_interceptors__h4min7($this);
  if ($this.m3t_1.p() || currentInterceptors == null) {
    return false;
  }
  var tmp;
  if ($this.p3t_1) {
    tmp = true;
  } else {
    tmp = !(!(currentInterceptors == null) ? isInterface(currentInterceptors, KtMutableList) : false);
  }
  if (tmp) {
    return false;
  }
  if (equals($this.q3t_1, phase)) {
    currentInterceptors.e(block);
    return true;
  }
  if (equals(phase, last($this.m3t_1)) || findPhaseIndex($this, phase) === get_lastIndex_0($this.m3t_1)) {
    ensureNotNull(findPhase($this, phase)).g3t(block);
    currentInterceptors.e(block);
    return true;
  }
  return false;
}
function Pipeline(phases) {
  this.k3t_1 = AttributesJsFn(true);
  this.l3t_1 = false;
  this.m3t_1 = mutableListOf(phases.slice());
  this.n3t_1 = 0;
  this.o3t_1 = atomic$ref$1(null);
  this.p3t_1 = false;
  this.q3t_1 = null;
}
protoOf(Pipeline).r3t = function () {
  return this.l3t_1;
};
protoOf(Pipeline).s3t = function (context, subject, $completion) {
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp$ret$0 = $completion.t8();
  return createContext(this, context, subject, tmp$ret$0).z3s(subject, $completion);
};
protoOf(Pipeline).u3t = function (reference, phase) {
  if (hasPhase(this, phase))
    return Unit_instance;
  var index = findPhaseIndex(this, reference);
  if (index === -1) {
    throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
  }
  var lastRelatedPhaseIndex = index;
  var inductionVariable = index + 1 | 0;
  var last = get_lastIndex_0(this.m3t_1);
  if (inductionVariable <= last)
    $l$loop_0: do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = this.m3t_1.o(i);
      var tmp0_safe_receiver = tmp instanceof PhaseContent ? tmp : null;
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.c3t_1;
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        break $l$loop_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var relation = tmp_0;
      var tmp2_safe_receiver = relation instanceof After ? relation : null;
      var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.v3t_1;
      var tmp_1;
      if (tmp3_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp_1 = tmp3_elvis_lhs;
      }
      var relatedTo = tmp_1;
      lastRelatedPhaseIndex = equals(relatedTo, reference) ? i : lastRelatedPhaseIndex;
    }
     while (!(i === last));
  this.m3t_1.f2(lastRelatedPhaseIndex + 1 | 0, PhaseContent_init_$Create$(phase, new After(reference)));
};
protoOf(Pipeline).w3t = function (reference, phase) {
  if (hasPhase(this, phase))
    return Unit_instance;
  var index = findPhaseIndex(this, reference);
  if (index === -1) {
    throw new InvalidPhaseException('Phase ' + reference.toString() + ' was not registered for this pipeline');
  }
  this.m3t_1.f2(index, PhaseContent_init_$Create$(phase, new Before(reference)));
};
protoOf(Pipeline).x3t = function (phase, block) {
  var tmp0_elvis_lhs = findPhase(this, phase);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw new InvalidPhaseException('Phase ' + phase.toString() + ' was not registered for this pipeline');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var phaseContent = tmp;
  if (tryAddToPhaseFastPath(this, phase, block)) {
    this.n3t_1 = this.n3t_1 + 1 | 0;
    return Unit_instance;
  }
  phaseContent.g3t(block);
  this.n3t_1 = this.n3t_1 + 1 | 0;
  resetInterceptorsList(this);
  this.y3t();
};
protoOf(Pipeline).y3t = function () {
};
protoOf(Pipeline).toString = function () {
  return anyToString(this);
};
function interceptors$factory() {
  return getPropertyCallableRef('interceptors', 1, KMutableProperty1, function (receiver) {
    return _get_interceptors__h4min7(receiver);
  }, function (receiver, value) {
    return _set_interceptors__wod97b(receiver, value);
  });
}
function interceptors$factory_0() {
  return getPropertyCallableRef('interceptors', 1, KMutableProperty1, function (receiver) {
    return _get_interceptors__h4min7(receiver);
  }, function (receiver, value) {
    return _set_interceptors__wod97b(receiver, value);
  });
}
function PipelineContext(context) {
  this.t3t_1 = context;
}
function pipelineContextFor(context, interceptors, subject, coroutineContext, debugMode) {
  debugMode = debugMode === VOID ? false : debugMode;
  var tmp;
  if (get_DISABLE_SFG() || debugMode) {
    tmp = new DebugPipelineContext(context, interceptors, subject, coroutineContext);
  } else {
    tmp = new SuspendFunctionGun(subject, context, interceptors);
  }
  return tmp;
}
function PipelinePhase(name) {
  this.j3t_1 = name;
}
protoOf(PipelinePhase).toString = function () {
  return "Phase('" + this.j3t_1 + "')";
};
function InvalidPhaseException(message) {
  extendThrowable(this, message);
  captureStack(this, InvalidPhaseException);
}
function After(relativeTo) {
  PipelinePhaseRelation.call(this);
  this.v3t_1 = relativeTo;
}
function Before(relativeTo) {
  PipelinePhaseRelation.call(this);
  this.z3t_1 = relativeTo;
}
function Last() {
  Last_instance = this;
  PipelinePhaseRelation.call(this);
}
protoOf(Last).toString = function () {
  return 'Last';
};
protoOf(Last).hashCode = function () {
  return 967869129;
};
protoOf(Last).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Last))
    return false;
  other instanceof Last || THROW_CCE();
  return true;
};
var Last_instance;
function Last_getInstance() {
  if (Last_instance == null)
    new Last();
  return Last_instance;
}
function PipelinePhaseRelation() {
}
function recoverStackTraceBridge(exception, continuation) {
  var tmp;
  try {
    tmp = withCause(recoverStackTrace(exception, continuation), exception.cause);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var _unused_var__etf5q3 = $p;
      tmp_0 = exception;
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function loop($this, direct) {
  do {
    var currentIndex = $this.g3u_1;
    if (currentIndex === $this.b3u_1.m()) {
      if (!direct) {
        // Inline function 'kotlin.Companion.success' call
        var value = $this.d3u_1;
        var tmp$ret$0 = _Result___init__impl__xyqfz8(value);
        resumeRootWith($this, tmp$ret$0);
        return false;
      }
      return true;
    }
    $this.g3u_1 = currentIndex + 1 | 0;
    var next = $this.b3u_1.o(currentIndex);
    try {
      var result = pipelineStartCoroutineUninterceptedOrReturn(next, $this, $this.d3u_1, $this.c3u_1);
      if (result === get_COROUTINE_SUSPENDED())
        return false;
    } catch ($p) {
      if ($p instanceof Error) {
        var cause = $p;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$1 = _Result___init__impl__xyqfz8(createFailure(cause));
        resumeRootWith($this, tmp$ret$1);
        return false;
      } else {
        throw $p;
      }
    }
  }
   while (true);
}
function resumeRootWith($this, result) {
  if ($this.f3u_1 < 0) {
    // Inline function 'kotlin.error' call
    var message = 'No more continuations to resume';
    throw IllegalStateException_init_$Create$(toString(message));
  }
  var next = ensureNotNull($this.e3u_1[$this.f3u_1]);
  var _unary__edvuaz = $this.f3u_1;
  $this.f3u_1 = _unary__edvuaz - 1 | 0;
  $this.e3u_1[_unary__edvuaz] = null;
  if (!_Result___get_isFailure__impl__jpiriv(result)) {
    next.y8(result);
  } else {
    var exception = recoverStackTraceBridge(ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result)), next);
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    next.y8(tmp$ret$0);
  }
}
function discardLastRootContinuation($this) {
  if ($this.f3u_1 < 0)
    throw IllegalStateException_init_$Create$('No more continuations to resume');
  var _unary__edvuaz = $this.f3u_1;
  $this.f3u_1 = _unary__edvuaz - 1 | 0;
  $this.e3u_1[_unary__edvuaz] = null;
}
function SuspendFunctionGun$continuation$1(this$0) {
  this.i3u_1 = this$0;
  this.h3u_1 = -2147483648;
}
protoOf(SuspendFunctionGun$continuation$1).t8 = function () {
  var continuation = this.i3u_1.e3u_1[this.i3u_1.f3u_1];
  if (!(continuation === this) && !(continuation == null))
    return continuation.t8();
  var index = this.i3u_1.f3u_1 - 1 | 0;
  while (index >= 0) {
    var _unary__edvuaz = index;
    index = _unary__edvuaz - 1 | 0;
    var cont = this.i3u_1.e3u_1[_unary__edvuaz];
    if (!(cont === this) && !(cont == null))
      return cont.t8();
  }
  // Inline function 'kotlin.error' call
  var message = 'Not started';
  throw IllegalStateException_init_$Create$(toString(message));
};
protoOf(SuspendFunctionGun$continuation$1).ag = function (result) {
  if (_Result___get_isFailure__impl__jpiriv(result)) {
    // Inline function 'kotlin.Companion.failure' call
    var exception = ensureNotNull(Result__exceptionOrNull_impl_p6xea9(result));
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    resumeRootWith(this.i3u_1, tmp$ret$0);
    return Unit_instance;
  }
  loop(this.i3u_1, false);
};
protoOf(SuspendFunctionGun$continuation$1).y8 = function (result) {
  return this.ag(result);
};
function SuspendFunctionGun(initial, context, blocks) {
  PipelineContext.call(this, context);
  this.b3u_1 = blocks;
  var tmp = this;
  tmp.c3u_1 = new SuspendFunctionGun$continuation$1(this);
  this.d3u_1 = initial;
  var tmp_0 = this;
  // Inline function 'kotlin.arrayOfNulls' call
  var size = this.b3u_1.m();
  tmp_0.e3u_1 = Array(size);
  this.f3u_1 = -1;
  this.g3u_1 = 0;
}
protoOf(SuspendFunctionGun).h1e = function () {
  return this.c3u_1.t8();
};
protoOf(SuspendFunctionGun).w3s = function () {
  return this.d3u_1;
};
protoOf(SuspendFunctionGun).y3s = function ($completion) {
  var tmp$ret$0;
  $l$block_0: {
    if (this.g3u_1 === this.b3u_1.m()) {
      tmp$ret$0 = this.d3u_1;
      break $l$block_0;
    }
    this.j3u(intercepted($completion));
    if (loop(this, true)) {
      discardLastRootContinuation(this);
      tmp$ret$0 = this.d3u_1;
      break $l$block_0;
    }
    tmp$ret$0 = get_COROUTINE_SUSPENDED();
  }
  return tmp$ret$0;
};
protoOf(SuspendFunctionGun).x3s = function (subject, $completion) {
  this.d3u_1 = subject;
  return this.y3s($completion);
};
protoOf(SuspendFunctionGun).z3s = function (initial, $completion) {
  this.g3u_1 = 0;
  if (this.g3u_1 === this.b3u_1.m())
    return initial;
  this.d3u_1 = initial;
  if (this.f3u_1 >= 0)
    throw IllegalStateException_init_$Create$('Already started');
  return this.y3s($completion);
};
protoOf(SuspendFunctionGun).j3u = function (continuation) {
  this.f3u_1 = this.f3u_1 + 1 | 0;
  this.e3u_1[this.f3u_1] = continuation;
};
function TypeInfo(type, kotlinType) {
  kotlinType = kotlinType === VOID ? null : kotlinType;
  this.k3u_1 = type;
  this.l3u_1 = kotlinType;
}
protoOf(TypeInfo).hashCode = function () {
  var tmp0_safe_receiver = this.l3u_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
  return tmp1_elvis_lhs == null ? this.k3u_1.hashCode() : tmp1_elvis_lhs;
};
protoOf(TypeInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TypeInfo))
    return false;
  var tmp;
  if (!(this.l3u_1 == null) || !(other.l3u_1 == null)) {
    tmp = equals(this.l3u_1, other.l3u_1);
  } else {
    tmp = this.k3u_1.equals(other.k3u_1);
  }
  return tmp;
};
protoOf(TypeInfo).toString = function () {
  var tmp0_elvis_lhs = this.l3u_1;
  return 'TypeInfo(' + toString(tmp0_elvis_lhs == null ? this.k3u_1 : tmp0_elvis_lhs) + ')';
};
function get_platform(_this__u8e3s4) {
  _init_properties_PlatformUtils_js_kt__7rxm8p();
  var tmp0 = platform$delegate;
  // Inline function 'kotlin.getValue' call
  platform$factory();
  return tmp0.t();
}
var platform$delegate;
function platform$delegate$lambda() {
  _init_properties_PlatformUtils_js_kt__7rxm8p();
  return new Js(hasNodeApi() ? JsPlatform_Node_getInstance() : JsPlatform_Browser_getInstance());
}
function platform$factory() {
  return getPropertyCallableRef('platform', 1, KProperty1, function (receiver) {
    return get_platform(receiver);
  }, null);
}
var properties_initialized_PlatformUtils_js_kt_8g036j;
function _init_properties_PlatformUtils_js_kt__7rxm8p() {
  if (!properties_initialized_PlatformUtils_js_kt_8g036j) {
    properties_initialized_PlatformUtils_js_kt_8g036j = true;
    platform$delegate = lazy_0(platform$delegate$lambda);
  }
}
function toJsArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toByteArray(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function GMTDate_0(timestamp) {
  timestamp = timestamp === VOID ? null : timestamp;
  var tmp1_safe_receiver = timestamp == null ? null : timestamp.j3();
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new Date(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  var date = tmp2_elvis_lhs == null ? new Date() : tmp2_elvis_lhs;
  if (isNaN_0(date.getTime()))
    throw new InvalidTimestampException(ensureNotNull(timestamp));
  // Inline function 'kotlin.with' call
  var dayOfWeek = Companion_instance_1.s3r((date.getUTCDay() + 6 | 0) % 7 | 0);
  var month = Companion_instance_2.s3r(date.getUTCMonth());
  return new GMTDate(date.getUTCSeconds(), date.getUTCMinutes(), date.getUTCHours(), dayOfWeek, date.getUTCDate(), date.getUTCFullYear(), month, date.getUTCFullYear(), numberToLong(date.getTime()));
}
function InvalidTimestampException(timestamp) {
  IllegalStateException_init_$Init$('Invalid date timestamp exception: ' + timestamp.toString(), this);
  captureStack(this, InvalidTimestampException);
}
function getTimeMillis() {
  return numberToLong((new Date()).getTime());
}
function pipelineStartCoroutineUninterceptedOrReturn(interceptor, context, subject, continuation) {
  return (typeof interceptor === 'function' ? interceptor : THROW_CCE())(context, subject, continuation);
}
function AttributesJsFn(concurrent) {
  concurrent = concurrent === VOID ? false : concurrent;
  return new AttributesJs();
}
function AttributesJs() {
  var tmp = this;
  // Inline function 'kotlin.collections.mutableMapOf' call
  tmp.m3u_1 = LinkedHashMap_init_$Create$();
}
protoOf(AttributesJs).t3o = function (key) {
  var tmp = this.m3u_1.a2(key);
  return (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
};
protoOf(AttributesJs).u3o = function (key) {
  return this.m3u_1.y1(key);
};
protoOf(AttributesJs).v3o = function (key, value) {
  // Inline function 'kotlin.collections.set' call
  this.m3u_1.h2(key, value);
};
protoOf(AttributesJs).w3o = function (key) {
  this.m3u_1.i2(key);
};
protoOf(AttributesJs).x3o = function (key, block) {
  var tmp0_safe_receiver = this.m3u_1.a2(key);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return !(tmp0_safe_receiver == null) ? tmp0_safe_receiver : THROW_CCE();
  }
  // Inline function 'kotlin.also' call
  var this_0 = block();
  // Inline function 'kotlin.collections.set' call
  this.m3u_1.h2(key, this_0);
  return this_0;
};
protoOf(AttributesJs).y3o = function () {
  return toList(this.m3u_1.b2());
};
function unmodifiable(_this__u8e3s4) {
  return _this__u8e3s4;
}
function get__crypto() {
  _init_properties_CryptoJs_kt__3vpuru();
  return _crypto;
}
var _crypto;
function generateNonce_0() {
  _init_properties_CryptoJs_kt__3vpuru();
  var buffer = toJsArray(new Int8Array(16));
  get__crypto().getRandomValues(buffer);
  return hex(toByteArray(buffer));
}
var properties_initialized_CryptoJs_kt_linsrw;
function _init_properties_CryptoJs_kt__3vpuru() {
  if (!properties_initialized_CryptoJs_kt_linsrw) {
    properties_initialized_CryptoJs_kt_linsrw = true;
    _crypto = globalThis ? globalThis.crypto : window.crypto || window.msCrypto;
  }
}
function hasNodeApi() {
  return typeof process !== 'undefined' && process.versions != null && process.versions.node != null || (typeof window !== 'undefined' && typeof window.process !== 'undefined' && window.process.versions != null && window.process.versions.node != null);
}
function get_isDevelopmentMode(_this__u8e3s4) {
  return false;
}
function initCauseBridge(_this__u8e3s4, cause) {
}
function KtorSimpleLogger(name) {
  return new KtorSimpleLogger$1();
}
function getKtorLogLevel() {
  return process.env.KTOR_LOG_LEVEL;
}
function KtorSimpleLogger$1() {
  var tmp = this;
  var tmp_0;
  switch (PlatformUtils_getInstance().y3p_1 || PlatformUtils_getInstance().x3p_1) {
    case true:
      // Inline function 'kotlin.runCatching' call

      var tmp_1;
      try {
        // Inline function 'kotlin.Companion.success' call
        var value = getKtorLogLevel();
        tmp_1 = _Result___init__impl__xyqfz8(value);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof Error) {
          var e = $p;
          // Inline function 'kotlin.Companion.failure' call
          tmp_2 = _Result___init__impl__xyqfz8(createFailure(e));
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }

      // Inline function 'kotlin.Result.getOrNull' call

      var this_0 = tmp_1;
      var tmp_3;
      if (_Result___get_isFailure__impl__jpiriv(this_0)) {
        tmp_3 = null;
      } else {
        var tmp_4 = _Result___get_value__impl__bjfvqg(this_0);
        tmp_3 = (tmp_4 == null ? true : !(tmp_4 == null)) ? tmp_4 : THROW_CCE();
      }

      var tmp1_safe_receiver = tmp_3;
      var tmp_5;
      if (tmp1_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0 = get_entries_1();
        var tmp$ret$6;
        $l$block: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s = tmp0.j();
          while (_iterator__ex2g4s.k()) {
            var element = _iterator__ex2g4s.l();
            if (element.k2_1 === tmp1_safe_receiver) {
              tmp$ret$6 = element;
              break $l$block;
            }
          }
          tmp$ret$6 = null;
        }
        tmp_5 = tmp$ret$6;
      }

      var tmp2_elvis_lhs = tmp_5;
      tmp_0 = tmp2_elvis_lhs == null ? LogLevel_INFO_getInstance() : tmp2_elvis_lhs;
      break;
    case false:
      tmp_0 = LogLevel_TRACE_getInstance();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  tmp.n3u_1 = tmp_0;
}
protoOf(KtorSimpleLogger$1).o3u = function (message) {
  if (this.n3u_1.m2(LogLevel_TRACE_getInstance()) > 0)
    return Unit_instance;
  console.debug('TRACE: ' + message);
};
var LogLevel_TRACE_instance;
var LogLevel_DEBUG_instance;
var LogLevel_INFO_instance;
var LogLevel_WARN_instance;
var LogLevel_ERROR_instance;
var LogLevel_NONE_instance;
function values_1() {
  return [LogLevel_TRACE_getInstance(), LogLevel_DEBUG_getInstance(), LogLevel_INFO_getInstance(), LogLevel_WARN_getInstance(), LogLevel_ERROR_getInstance(), LogLevel_NONE_getInstance()];
}
function get_entries_1() {
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var LogLevel_entriesInitialized;
function LogLevel_initEntries() {
  if (LogLevel_entriesInitialized)
    return Unit_instance;
  LogLevel_entriesInitialized = true;
  LogLevel_TRACE_instance = new LogLevel('TRACE', 0);
  LogLevel_DEBUG_instance = new LogLevel('DEBUG', 1);
  LogLevel_INFO_instance = new LogLevel('INFO', 2);
  LogLevel_WARN_instance = new LogLevel('WARN', 3);
  LogLevel_ERROR_instance = new LogLevel('ERROR', 4);
  LogLevel_NONE_instance = new LogLevel('NONE', 5);
}
var $ENTRIES_1;
function LogLevel(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function get_isTraceEnabled(_this__u8e3s4) {
  return true;
}
function LogLevel_TRACE_getInstance() {
  LogLevel_initEntries();
  return LogLevel_TRACE_instance;
}
function LogLevel_DEBUG_getInstance() {
  LogLevel_initEntries();
  return LogLevel_DEBUG_instance;
}
function LogLevel_INFO_getInstance() {
  LogLevel_initEntries();
  return LogLevel_INFO_instance;
}
function LogLevel_WARN_getInstance() {
  LogLevel_initEntries();
  return LogLevel_WARN_instance;
}
function LogLevel_ERROR_getInstance() {
  LogLevel_initEntries();
  return LogLevel_ERROR_instance;
}
function LogLevel_NONE_getInstance() {
  LogLevel_initEntries();
  return LogLevel_NONE_instance;
}
function get_DISABLE_SFG() {
  return DISABLE_SFG;
}
var DISABLE_SFG;
function withCause(_this__u8e3s4, cause) {
  return _this__u8e3s4;
}
function instanceOf(_this__u8e3s4, type) {
  return type.qa(_this__u8e3s4);
}
//region block: post-declaration
protoOf($serializer).qz = typeParametersSerializers;
protoOf(AttributesJs).s3o = get;
//endregion
//region block: init
Companion_instance_1 = new Companion_0();
Companion_instance_2 = new Companion_1();
DISABLE_SFG = false;
//endregion
//region block: exports
export {
  PlatformUtils_getInstance as PlatformUtils_getInstance3trl22jwg7wgb,
  ChannelIOException as ChannelIOException2i3t76lsrbgox,
  CopyOnWriteHashMap as CopyOnWriteHashMap2wz01l72sexe7,
  GMTDate_0 as GMTDate36bhedawynxlf,
  getTimeMillis as getTimeMillis12o7k17x9fmwi,
  LockFreeLinkedListNode as LockFreeLinkedListNode1f5fxflchw0ko,
  initCauseBridge as initCauseBridge1upxfqhavblt6,
  KtorSimpleLogger as KtorSimpleLogger1xdphsp5l4e48,
  get_isTraceEnabled as get_isTraceEnabled82xibuu04nxp,
  PipelineContext as PipelineContext34fsb0mycu471,
  PipelinePhase as PipelinePhase2q3d54imxjlma,
  Pipeline as Pipeline2vw6c5wpzxajt,
  TypeInfo as TypeInfo2nbxsuf4v8os2,
  instanceOf as instanceOf2cx3k00nj6a0p,
  AttributeKey as AttributeKey3aq8ytwgx54f7,
  AttributesJsFn as AttributesJsFn25rjfgcprgprf,
  Attributes as Attributes2dg90yv0ot9wx,
  SilentSupervisor as SilentSupervisorlzoikirj0zeo,
  forEach as forEachghjt92rkrpzo,
  get_0 as get3oezx9z3zutmm,
  StringValuesBuilderImpl as StringValuesBuilderImpl3ey9etj3bwnqf,
  StringValuesImpl as StringValuesImpl2l95y9du7b61t,
  StringValuesSingleImpl as StringValuesSingleImpl1uh7q2c2zm7va,
  StringValues as StringValuesjqid5a6cuday,
  appendAll as appendAlltwnjnu28pmtx,
  appendIfNameAbsent as appendIfNameAbsent2ezf2rzparych,
  encodeBase64 as encodeBase6432vm5zx1em8c4,
  generateNonce as generateNonce3td15vdvbmmke,
  hex as hex2ofqpe9ngcu1i,
  isLowerCase as isLowerCase2jodys5jo7d58,
  putAll as putAll10o0q8e6mgnzr,
  toCharArray as toCharArray1qby3f4cdahde,
  toLowerCasePreservingASCIIRules as toLowerCasePreservingASCIIRulesa2d90zyoc6kw,
};
//endregion

